export const MESSAGES = {
    COMMON: {
        MISSING_DAICD: "daicd が見つかりません。",
        NOTE_LIST_LENGTH_ZERO: "送信するメッセージはありません。"
    },
    CARECONNE: {
        ERR_CONTENT_TOO_LARGE: "送信できませんでした。\n添付ファイルの容量(10MB)を超えています。",
    }
}

export const MEDIA_REGISTRY = [
    {
        name: 'delete',
        path: '/assets/images/icon/delete.svg'
    },
    {
        name: 'duplicate',
        path: '/assets/images/icon/duplicate.svg'
    },
    {
        name: 'edit',
        path: '/assets/images/icon/edit.svg'
    },
    {
        name: 'wrench',
        path: '/assets/images/icon/wrench.svg'
    },
    {
        name: 'user-avatar',
        path: '/assets/images/icon/user-avatar.svg'
    },
    {
        name: 'avatar',
        path: '/assets/images/icon/avatar.svg'
    },
    {
        name: 'menu',
        path: '/assets/images/icon/menu.svg'
    },
    {
        name: 'done',
        path: '/assets/images/icon/done.svg'
    },
    {
        name: 'change',
        path: '/assets/images/icon/change.svg'
    },
    {
        name: 'search',
        path: '/assets/images/icon/search.svg'
    },
    {
        name: 'expand',
        path: '/assets/images/icon/ic-expand.svg'
    },
    {
        name: 'close',
        path: '/assets/images/icon/close.svg'
    },
    {
        name: 'care-conne-close',
        path: '/assets/images/icon/care-conne-close.svg'
    },
    {
        name: 'care-conne-back',
        path: '/assets/images/icon/care-conne-back.svg'
    },
    {
        name: 'check-circle',
        path: '/assets/images/icon/check-circle.svg'
    },
    {
        name: 'facesheet',
        path: '/assets/images/icon/facesheet.svg'
    },
    {
        name: 'excelIcon',
        path: '/assets/images/icon/excel.svg'
    },
    {
        name: 'pdfIcon',
        path: '/assets/images/icon/pdf.svg'
    },
    {
        name: 'powerpointIcon',
        path: '/assets/images/icon/powerpoint.svg'
    },
    {
        name: 'wordIcon',
        path: '/assets/images/icon/word.svg'
    },
    {
        name: 'documentIcon',
        path: '/assets/images/icon/unknown-file.svg'
    },
    {
        name: 'videoIcon',
        path: '/assets/images/icon/video-file.svg'
    },
    {
        name: 'plus',
        path: '/assets/images/icon/plus.svg'
    },
    {
        name: 'ic-plus',
        path: '/assets/images/icon/ic-plus.svg'
    },
    {
        name: 'arrow',
        path: '/assets/images/icon/arrow-left.svg'
    },
    {
        name: 'calendar',
        path: '/assets/images/icon/calendar.svg'
    },
    {
        name: 'check',
        path: '/assets/images/icon/check.svg'
    },
    {
        name: 'exclamation',
        path: '/assets/images/icon/exclamation.svg'
    },
    {
        name: 'clock',
        path: '/assets/images/icon/clock.svg'
    },
    {
        name: 'calendar-grey',
        path: '/assets/images/icon/calendar-grey.svg'
    }
];

export const FOOTER_MENU_ITEMS = [
    {
        label: '記録',
        icon: 'description',
        link: '/home/list'
    },
    {
        label: '連絡帳',
        icon: 'schedule',
        link: '/home/testing'
    }
];
